import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "How long does setup take?",
    a: "Most businesses are live within 2 business days. Once you submit your details we configure your widget with your exact services and pricing. We then email you your embed code — a single line of code to paste into your website — and it is also available anytime in your account. The whole process takes about 2 minutes on your end.",
  },
  {
    q: "Do I need to be technical?",
    a: "Not at all. If you can copy and paste, you can install the widget. We also provide step-by-step guides for WordPress, Squarespace, Wix, and Webflow.",
  },
  {
    q: "Can I customise the services and prices?",
    a: "Yes — your widget is fully configured to match your exact services, pricing structure, and brand colours.",
  },
  {
    q: "What happens when a customer accepts a quote?",
    a: "You receive an instant email with their name, phone number, email address, and the full quote details. The customer receives a confirmation that you'll be in touch within your nominated timeframe.",
  },
  {
    q: "Will it work on my existing website?",
    a: "Yes. The widget embeds into any website platform via a simple code snippet. It works on WordPress, Squarespace, Wix, Webflow, and any custom-built site.",
  },
  {
    q: "What does the free trial include?",
    a: "Full access to everything — configured widget, unlimited quotes, and email notifications — for 28 days. No charge until the trial ends.",
  },
  {
    q: "Is there a lock-in contract?",
    a: "No. Cancel anytime. If you cancel before your trial ends you won't be charged at all.",
  },
  {
    q: "What if my pricing changes?",
    a: "Just email us with any changes and we will update your widget — usually within one business day.",
  },
  {
    q: "Is my customers' data secure?",
    a: "Yes. All customer data is encrypted in transit and at rest. It is stored securely and used only to connect them with your business.",
  },
  {
    q: "What if I need help?",
    a: "Email us anytime at support@genquotes.com. We typically respond within a few hours during business days.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-20 sm:py-24 bg-[#0A1628]">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="uppercase text-xs tracking-widest text-[#06B6D4] font-mono">FAQ</div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
            Questions, answered.
          </h2>
        </div>

        <div className="divide-y divide-white/5 border-y border-white/5 rounded-2xl overflow-hidden so-card">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <button
                key={i}
                type="button"
                data-testid={`faq-item-${i}`}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full text-left px-5 sm:px-6 py-5 transition-colors hover:bg-white/[0.02] focus:outline-none"
                aria-expanded={isOpen}
              >
                <div className="flex items-start justify-between gap-4">
                  <span className="font-medium text-[15px] sm:text-base text-[#F8FAFC] flex-1">
                    {item.q}
                  </span>
                  <ChevronDown
                    size={18}
                    className={`shrink-0 text-[#06B6D4] transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </div>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] mt-3 opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-[#94A3B8] text-sm leading-relaxed pr-6">
                      {item.a}
                    </p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
